const METRICS = [
  { label: "META ADS ROAS", value: "3x-4x", color: "#00E699" },
  { label: "GOOGLE ADS ROAS", value: "3x-4x", color: "#00E699" },
  { label: "AVG. THUMBNAIL CTR", value: "5-7%", color: "#FFB800" },
  { label: "SOCIAL MEDIA GROWTH", value: "30-40%", color: "#00C2FF" },
  { label: "CREATIVES SHIPPED · LAST 6 MONTHS", value: "500+", color: "#FF4D23" },
  { label: "YEARS IN DESIGN", value: "9+", color: "#FFB800" },
];

export default function ImpactBar({ metrics }) {
  const items = metrics?.length ? metrics : METRICS;
  const doubled = [...items, ...items];
  return (
    <section id="impact" data-testid="impact-bar" className="border-y border-[#222634] bg-[#12141B]/50 py-6 overflow-hidden">
      <p className="text-center text-[10px] font-mono2 tracking-[0.35em] uppercase text-[#8A92A3] mb-4">
        Design measured by business outcomes
      </p>
      <div className="flex w-max animate-marquee gap-10 px-4">
        {doubled.map((m, i) => (
          <div key={i} className="flex items-center gap-3 shrink-0" data-testid={`impact-metric-${i % items.length}`}>
            <span className="w-2 h-2 rounded-full" style={{ background: m.color }} />
            <span className="font-mono2 font-bold text-lg" style={{ color: m.color }}>
              {m.value}
            </span>
            <span className="text-xs font-mono2 tracking-widest text-[#A0A7B8] uppercase">{m.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
